{
  "auth": {
    "logoAlt": "Smart Word Labs",
    "checkEmail": {
      "title": "تحقق من بريدك الإلكتروني",
      "confirmationBody": "أرسلنا رابط تأكيد إلى <strong>{{email}}</strong>. قم بتأكيده لتفعيل حسابك، ثم سجّل الدخول.",
      "magicLinkBody": "أرسلنا رابط تسجيل دخول لمرة واحدة إلى <strong>{{email}}</strong>. افتحه على هذا الجهاز لتسجيل الدخول.",
      "backToSignIn": "العودة إلى تسجيل دخول أولياء الأمور"
    },
    "heading": {
      "magicMode": "تسجيل الدخول بالرابط السحري",
      "signup": "أنشئ حساب ولي الأمر",
      "signin": "تسجيل دخول أولياء الأمور"
    },
    "subheading": {
      "magicMode": "أدخل بريدك الإلكتروني وسنرسل لك رابط تسجيل دخول لمرة واحدة.",
      "signup": "أدر دروس أطفالك والفوترة والتقدم في مكان واحد.",
      "signin": "سجّل الدخول إلى بوابة أولياء الأمور الخاصة بك."
    },
    "social": {
      "google": "المتابعة باستخدام جوجل",
      "apple": "المتابعة باستخدام آبل"
    },
    "or": "أو",
    "fields": {
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "fullName": "الاسم الكامل",
      "country": "الدولة",
      "phone": "الهاتف"
    },
    "buttons": {
      "pleaseWait": "يرجى الانتظار…",
      "sendMagicLink": "إرسال الرابط السحري",
      "createAccount": "إنشاء حساب",
      "signIn": "تسجيل الدخول"
    },
    "toggle": {
      "useMagicLink": "أرسل لي رابطًا سحريًا بدلاً من ذلك",
      "usePassword": "استخدم البريد الإلكتروني وكلمة المرور بدلاً من ذلك"
    },
    "footer": {
      "haveAccount": "هل لديك حساب بالفعل؟",
      "signIn": "تسجيل الدخول",
      "newHere": "جديد على Smart Word Labs؟",
      "bookAssessment": "احجز تقييمًا مجانيًا"
    },
    "errors": {
      "couldNotSignIn": "تعذّر تسجيل الدخول",
      "enterEmailFirst": "أدخل بريدك الإلكتروني أولاً",
      "somethingWentWrong": "حدث خطأ ما"
    },
    "toasts": {
      "magicLinkSent": "تم إرسال رابط تسجيل الدخول — تحقق من بريدك الإلكتروني"
    }
  },
  "reviews": {
    "title": "آراء أولياء الأمور",
    "description": "آراء صادقة من العائلات التي تتعلم مع Smart Word Labs. شارك تجربتك أدناه — ستظهر المراجعات هنا بمجرد مراجعتها.",
    "starsAriaLabel": "{{rating}} من 5 نجوم",
    "starPickerAriaLabel": "تقييم بالنجوم",
    "starAriaLabel": "{{count}} نجمة",
    "starAriaLabel_plural": "{{count}} نجوم",
    "whatParentsSay": "ماذا يقول أولياء الأمور",
    "empty": "لا توجد مراجعات منشورة بعد — قد تكون مراجعتك الأولى.",
    "form": {
      "title": "اكتب مراجعة",
      "yourRating": "تقييمك",
      "yourName": "اسمك",
      "email": "البريد الإلكتروني (اختياري، لن يُنشر)",
      "childAge": "عمر الطفل (اختياري)",
      "location": "المدينة / الدولة (اختياري)",
      "yourReview": "مراجعتك",
      "bodyPlaceholder": "ما الذي تغيّر بالنسبة لطفلك؟ ما الذي تقدّره في الدروس؟",
      "website": "الموقع الإلكتروني",
      "submit": "إرسال المراجعة"
    },
    "sent": {
      "title": "تم استلام المراجعة",
      "body": "شكرًا لمشاركة تجربتك. ننشر المراجعات بعد مراجعة سريعة.",
      "writeAnother": "اكتب مراجعة أخرى"
    },
    "errors": {
      "chooseRating": "يرجى اختيار تقييم بالنجوم.",
      "tooFast": "كان ذلك سريعًا جدًا! يرجى أخذ لحظة والمحاولة مرة أخرى.",
      "bodyTooShort": "يرجى كتابة جملتين على الأقل.",
      "checkForm": "يرجى مراجعة النموذج",
      "saveFailed": "تعذّر حفظ مراجعتك. يرجى المحاولة مرة أخرى."
    },
    "toasts": {
      "submitted": "شكرًا — تم إرسال مراجعتك للمراجعة."
    }
  }
}
